import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-6">
      <div className="max-w-6xl mx-auto px-4 text-center space-y-3">

        {/* Copyright */}
        <p className="text-sm">
          &copy; {new Date().getFullYear()} FareFuel. All rights reserved.
        </p>

        {/* Divider */}
        <div className="w-12 h-[1px] bg-gray-500 mx-auto"></div>

        {/* Disclaimer */}
        <p className="text-xs text-gray-300 max-w-2xl mx-auto leading-relaxed">
          FareFuel does not provide investment, brokerage, or financial advisory services.
          The platform enables users to earn and use recycling rewards for approved services.
        </p>

      </div>
    </footer>
  );
};

export default Footer;